import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { PostDatedPrescriptionCount } from "../../Apis/AuthApiServices";
import {
  loadingPostDatedPresCount,
  setPostDatedPresCount,
} from "../Slice/PostDatedPresCountSlice";

function* onLoadPostDatedPresCountAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield PostDatedPrescriptionCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setPostDatedPresCount({
          PostDatedPresCountData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setPostDatedPresCount({
          PostDatedPresCountData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setPostDatedPresCount({
        PostDatedPresCountData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadPostDatedPresCount() {
  yield takeLatest(
    loadingPostDatedPresCount.type,
    onLoadPostDatedPresCountAsync
  );
}

const PostDatedPresCountSaga = [fork(onLoadPostDatedPresCount)];
export default PostDatedPresCountSaga;
